import { MaggieHttp } from '../MaggieHttp';

export interface ResetReingestionResult {
  rowsMarked: number;
  reloadTriggered: boolean;
  message: string;
}

export interface ReprocessScope {
  companyIds?: number[];
  fundIds?: number[];
}

export async function reprocessForReingestion(scope: ReprocessScope, triggerReload = false) {
  const { data } = await MaggieHttp.maggie.post<
    ReprocessScope & { triggerReload: boolean },
    ResetReingestionResult
  >('/investran/reprocess', { ...scope, triggerReload });
  return data;
}
